/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoAllergiaDTO
 */
export interface AssistitoAllergiaDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoAllergiaDTO interface.
 */
export function instanceOfAssistitoAllergiaDTO(value: object): value is AssistitoAllergiaDTO {
    return true;
}

export function AssistitoAllergiaDTOFromJSON(json: any): AssistitoAllergiaDTO {
    return AssistitoAllergiaDTOFromJSONTyped(json, false);
}

export function AssistitoAllergiaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoAllergiaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoAllergiaDTOToJSON(value?: AssistitoAllergiaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

